var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSummary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7775 20.9997H5.44438C4.26566 20.9997 3.13521 20.5315 2.30173 19.698C1.46825 18.8645 1 17.7341 1 16.5553V3.22219C1 2.63283 1.23412 2.06761 1.65086 1.65086C2.06761 1.23412 2.63283 1 3.22219 1H14.3332C14.9225 1 15.4877 1.23412 15.9045 1.65086C16.3212 2.06761 16.5553 2.63283 16.5553 3.22219V17.6664C16.5553 19.5075 16.9365 20.9997 18.7775 20.9997Z",
    stroke: "#FEFEFE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 8.77786C21 8.18849 20.7659 7.62327 20.3492 7.20653C19.9324 6.78979 19.3672 6.55566 18.7779 6.55566H16.5557V18.2222C16.5557 19.7555 17.2445 20.9999 18.7779 20.9999C20.3112 20.9999 21 19.7555 21 18.2222V8.77786Z",
    stroke: "#FEFEFE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1109 9.88872H5.44434M12.1109 5.44434H5.44434M8.77762 14.3331H5.44434",
    stroke: "#FEFEFE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummary);
export default __webpack_public_path__ + "static/media/summary.104ee35ae92c69dd7afd79e57bb98579.svg";
export { ForwardRef as ReactComponent };